import React from 'react'
import Users from './components/Users'

const App = () => {
  return <Users />
}

export default App
